// show();
//
// function show(){
//     frequency = document.getElementById("fIn").value;
//     document.getElementById("fOut").innerHTML=frequency + ' Hz';
//
//     switch(document.getElementById("tIn").value * 1){
//         case 0: type='sine'; break;
//         case 1: type='square'; break;
//         case 2: type='sawtooth'; break;
//         case 3: type='triangle'; break;
//     }
//     document.getElementById("tOut").innerHTML=type;
//
//     volume = document.getElementById("vIn").value / 100;
//     document.getElementById("vOut").innerHTML=volume;
//
//     duration = document.getElementById("dIn").value;
//     document.getElementById("dOut").innerHTML=duration + ' ms';
// }
const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
const defaultValues = {
    volume: 0.2,
    frequency: 666,
    type: "sine"
}; //sine;square;sawtooth;triangle;
async function beep(duration, frequency = defaultValues["frequency"], volume = defaultValues["volume"], type = defaultValues["type"]) {
    let oscillator = audioCtx.createOscillator();
    let gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    gainNode.gain.value = volume;
    oscillator.frequency.value = frequency;
    oscillator.type = type;

    oscillator.start();
    return new Promise(resolve => {
        setTimeout(
            function () {
                oscillator.stop();
                resolve("anything");
            },
            duration
        );
    });
}

export async function playBeep(duration, frequency = defaultValues["frequency"], volume = defaultValues["volume"], type = defaultValues["type"]) {
    await beep(duration, frequency, volume, type);
}
export async function wait(duration) {
    return new Promise(resolve => {
        setTimeout(
            ()=>{resolve("anything");},
            duration
        );
    });
}

export default {playBeep,wait}